const classifyBill = () =>
  import("@/components/platform/classifyBill/classifyBill");
const reimbursement = () =>
  import("@/components/platform/reimbursement/reimbursement"); //报销单模板
//会计准则
const accountingStandard = () =>
  import("@/components/agency/accountingStandard/newAccountingStandard");
//科目设置SubjectAdd
const SubjectSetting = () =>
  import("@/components/agency/SubjectSetting/newSubjectSetting");
//增加科目
const SubjectAdd = () => import("@/components/agency/SubjectAdd/SubjectAdd");
//币种设置
const currecySet = () => import("@/components/agency/currecySet/newCurrecySet");
//币种汇率
const currencyRates = () =>
  import("@/components/agency/currencyRates/currencyRates");
// 类别配置
const sortDeploy = () => import("@/components/agency/sortDeploy/sortDeploy");
// 增加配置
const deployAdd = () => import("@/components/agency/sortDeploy/deployAdd");
// 票据模板设置
const paperTemplate = () =>
  import("@/components/agentAccount/paper-template/paper-template");
const SetpaperTemplate = () =>
  import("@/components/agentAccount/SetpaperTemplate/SetpaperTemplate");
const certificationTemplate = () =>
  import(
    "@/components/agentAccount/certificationTemplate/certificationTemplate"
  );
const certiPaperTemplate = () =>
  import("@/components/agentAccount/certificationTemplate/certiPaperTemplate");
// 资金模板
const capitalTemplate = () =>
  import("@/components/agency/capitalTemplate/index");
const vouTemplate = () =>
  import("@/components/agency/capitalTemplate/vouTemplate");
// 结转凭证模板设置
const SetTheTemplate = () =>
  import("@/components/agentAccount/SetTheTemplate/SetTheTemplate");
// 结转凭证模板新增
const newTemplate = () =>
  import("@/components/agentAccount/newTemplate/newTemplate");
//检查并结账
const checkAndSettle = () =>
  import("@/components/agency/checkAndSettle/checkAndSettle");
// 期末凭证
const finalProof = () =>
  import("@/components/agentAccount/finalProof/finalProof");
// 费用票据相关
const costBill = () => import("@/components/platform/bills/cost/index");
const costBillIndex = () => import("@/components/platform/bills/cost/cost");
const templateFund = () =>
  import("@/components/platform/bills/cost/templateFund");
// 薪酬管理
const paymentManageIndex = () => import("@/components/paymentManage/index"); //
const accountCompany = () =>
  import("@/components/paymentManage/accountCom/index"); //

const assetList = () =>
  import("@/components/agentAccount/maintainAsset/assetList.vue");
//新报表设置
const newListSet = () =>
  import("@/components/agency/report-forms/new/list-set-new");

//迁移配置，采集进度，迁移进度，迁移任务明细
const migrationConfig = () =>
  import("@/components/setMigration/migrationConfig/index");
const migrationGather = () =>
  import("@/components/setMigration/migrationGather/index");
const gatherDetails = () =>
  import(
    "@/components/setMigration/migrationGather/components/gatherDetails.vue"
  );
const acquisitionProgress = () =>
  import("@/components/setMigration/acquisitionProgress/index");
const migrationProgress = () =>
  import("@/components/setMigration/migrationProgress/index");
const migrationDetails = () =>
  import("@/components/setMigration/migrationDetails/index");
// const outConfirm = () => import('@/components/setMigration/migrationConfig/components/outConfirm');//搜索
const setMigration = () =>
  import(
    "@/components/setMigration/acquisitionProgress/components/setMigration"
  );
// 报税期设置
const taxReturnSet = () => import("@/components/taxTable/taxReturnSet/index");
//  沙箱管理,白名单，沙箱配置，服务映射
const whiteList = () => import("@/components/sandboxManage/whiteList/index");
const sandboxConfig = () =>
  import("@/components/sandboxManage/sandboxConfig/index");
const serviceMapping = () =>
  import("@/components/sandboxManage/serviceMapping/index");

// 银行回单解析
const bankAnalysis = () => import("@/components/bankClassify/bankAnalysis.vue");
const flagLog = () => import("@/components/bankClassify/flagLog.vue");
const bankOverview = () => import("@/components/bankClassify/bankOverview.vue");
const kindFlagA = () => import("@/components/bankClassify/kindFlagA.vue");
const kindFlagB = () => import("@/components/bankClassify/kindFlagB.vue");
const flagResult = () => import("@/components/bankClassify/flagResult.vue");

//币种设置
const enterpriseList = () => import("@/components/agency/enterpriseList/index");
export default [
  {
    path: "/classifyBill",
    name: "classifyBill",
    meta: {
      belong: ["tax"],
      text: "票据分类",
    },
    component: classifyBill,
  },
  {
    path: "/reimbursement",
    name: "reimbursement",
    meta: {
      belong: ["tax"],
      text: "报销单模板",
    },
    component: reimbursement,
  },
  {
    //会计准则
    path: "/accountingStandard",
    meta: {
      belong: ["tax"],
      text: "会计准则",
    },
    name: "accountingStandard",
    component: accountingStandard,
  },
  {
    //类别配置
    path: "/sortDeploy",
    meta: {
      belong: ["tax"],
      text: "类别配置",
    },
    name: "sortDeploy",
    component: sortDeploy,
  },
  {
    //增加类别配置
    path: "/deployAdd",
    meta: {
      belong: ["tax"],
      text: "类别配置",
    },
    name: "deployAdd",
    component: deployAdd,
  },
  {
    //科目设置
    path: "/SubjectSetting",
    meta: {
      belong: ["tax"],
      text: "科目设置",
    },
    name: "SubjectSetting",
    component: SubjectSetting,
  },
  {
    //增加科目
    path: "/SubjectAdd",
    meta: {
      belong: ["tax"],
      text: "增加科目",
    },
    name: "SubjectAdd",
    component: SubjectAdd,
  },
  {
    //币种设置
    path: "/currecySet",
    name: "currecySet",
    meta: {
      belong: ["tax"],
      text: "币种设置",
    },
    component: currecySet,
  },
  // 期末结转凭证模板
  {
    path: "/newTemplate",
    name: "newTemplate",
    meta: {
      belong: ["tax"],
      text: "期末结转模板",
    },
    component: newTemplate,
  },
  {
    path: "",
    component: (resolve) => {
      require(["@//components/agentAccount/finalProof/index.vue"], resolve);
    },
    children: [
      {
        // 期末凭证
        path: "/finalProof",
        name: "finalProof",
        component: finalProof,
        meta: {
          store: true,
          text: "期末凭证",
        },
      },
      {
        //检查并结账
        path: "/checkAndSettle",
        name: "checkAndSettle",
        component: checkAndSettle,
        meta: {
          store: true,
          text: "检查并结账",
        },
      },
    ],
  },
  {
    path: "/capitalTemplate",
    name: "capitalTemplate",
    meta: {
      belong: ["tax"],
      text: "资金模板",
    },
    component: capitalTemplate,
  },
  {
    path: "/vouTemplate",
    name: "vouTemplate",
    meta: {
      belong: ["tax"],
      text: "新增模板",
    },
    component: vouTemplate,
  },
  {
    path: "/SetTheTemplate",
    name: "SetTheTemplate",
    meta: {
      belong: ["tax"],
      text: "期末模板设置",
    },
    component: SetTheTemplate,
  },
  {
    path: "/certiPaperTemplate",
    meta: {
      belong: ["tax"],
      text: "业务模型",
    },
    name: "certiPaperTemplate",
    component: certiPaperTemplate,
  },
  {
    path: "/certificationTemplate",
    name: "certificationTemplate",
    meta: {
      belong: ["tax"],
      text: "模板编辑",
    },
    component: certificationTemplate,
  },
  {
    path: "/SetpaperTemplate",
    name: "SetpaperTemplate",
    meta: {
      belong: ["tax"],
      text: "添加票据模板",
    },
    component: SetpaperTemplate,
  },
  {
    path: "/paperTemplate",
    name: "paperTemplate",
    meta: {
      belong: ["tax"],
      text: "票据模板",
    },
    component: paperTemplate,
  },
  {
    path: "/costBill",
    component: costBill,
    children: [
      {
        path: "index",
        name: "costBill",
        meta: {
          belong: ["tax"],
          text: "费用模板",
        },
        component: costBillIndex,
      },
      {
        path: "templateFund",
        name: "templateFund",
        meta: {
          belong: ["tax"],
          text: "资金模板",
        },
        component: templateFund,
      },
    ],
  },
  // 薪酬管理
  {
    meta: {
      text: "薪酬管理",
    },
    path: "/paymentManageIndex",
    component: paymentManageIndex,
  },
  {
    meta: {
      store: true,
      text: "薪酬管理",
    },
    path: "/accountCompany",
    component: accountCompany,
  },
  {
    path: "/plat/assetList/visibleProperty",
    name: "assetList",
    meta: {
      belong: ["tax"],
      text: "资产维护",
    },
    component: assetList,
  },
  {
    //报表设置
    path: "newListSet",
    component: newListSet,
    children: [
      {
        meta: {
          text: "报表设置",
        },
        path: "",
        // 报表列表
        component: (resolve) => {
          require(["@//components/agency/report-forms/new/list.vue"], resolve);
        },
      },
      {
        meta: {
          text: "报表设置",
          noStore: true,
        },
        path: "deploy",
        name: "deploy",
        // 报表新增编辑
        component: (resolve) => {
          require([
            "@//components/agency/report-forms/new/deploy.vue",
          ], resolve);
        },
      },
    ],
  },
  // 账套迁移2
  {
    name: "migrationConfig",
    meta: {
      belong: ["tax"],
      text: "账套迁移",
    },
    path: "/migrationConfig",
    //迁移配置
    component: migrationConfig,
  },
  {
    name: "migrationGather",
    meta: {
      belong: ["tax"],
      text: "账套下载",
    },
    path: "/migrationGather",
    //迁移配置
    component: migrationGather,
  },
  {
    name: "gatherDetails",
    meta: {
      belong: ["tax"],
      text: "账套下载明细",
    },
    path: "/gatherDetails",
    //迁移配置
    component: gatherDetails,
  },
  {
    name: "acquisitionProgress",
    meta: {
      belong: ["tax"],
      text: "账套迁移",
    },
    path: "/acquisitionProgress",
    //采集进度
    component: acquisitionProgress,
  },
  {
    name: "setMigration",
    meta: {
      belong: ["tax"],
      text: "账套迁移",
    },
    path: "/setMigration",
    //采集进度-帐套迁移
    component: setMigration,
  },
  {
    name: "migrationProgress",
    meta: {
      belong: ["tax"],
      text: "账套迁移",
    },
    path: "/migrationProgress",
    //迁移进度
    component: migrationProgress,
  },
  {
    name: "migrationDetails",
    meta: {
      belong: ["tax"],
      text: "账套迁移",
    },
    path: "/migrationDetails",
    //迁移任务明细
    component: migrationDetails,
  },
  // 沙箱管理
  {
    name: "whiteList",
    meta: {
      belong: ["tax"],
      text: "白名单",
    },
    path: "/whiteList",
    //迁移配置
    component: whiteList,
  },
  {
    name: "serviceMapping",
    meta: {
      belong: ["tax"],
      text: "服务映射",
    },
    path: "/serviceMapping",
    //迁移配置
    component: serviceMapping,
  },
  {
    name: "sandboxConfig",
    meta: {
      belong: ["tax"],
      text: "沙箱配置",
    },
    path: "/sandboxConfig",
    //迁移配置
    component: sandboxConfig,
  },
  {
    name: "taxReturnSet",
    meta: {
      belong: ["tax"],
      text: "报税期设置",
    },
    path: "/taxReturnSet",
    //迁移任务明细
    component: taxReturnSet,
  },
  {
    name: "bankAnalysis",
    meta: {
      belong: ["tax"],
      text: "银行回单解析",
    },
    path: "/bankAnalysis",
    //银行回单解析
    component: bankAnalysis,
  },
  {
    name: "flagLog",
    meta: {
      belong: ["tax"],
      text: "标记日志",
    },
    path: "/flagLog",
    //标记日志
    component: flagLog,
  },
  {
    name: "bankOverview",
    meta: {
      belong: ["tax"],
      text: "银行流水总览",
    },
    path: "/bankOverview",
    //标记日志
    component: bankOverview,
  },
  {
    name: "kindFlagA",
    meta: {
      belong: ["tax"],
      text: "A组分类标记",
    },
    path: "/kindFlagA",
    //标记日志
    component: kindFlagA,
  },
  {
    name: "kindFlagB",
    meta: {
      belong: ["tax"],
      text: "B组分类标记",
    },
    path: "/kindFlagB",
    //标记日志
    component: kindFlagB,
  },
  {
    name: "flagResult",
    meta: {
      belong: ["tax"],
      text: "标记识别结果",
    },
    path: "/flagResult",
    //标记日志
    component: flagResult,
  },
  {
    //企业列表
    path: "/enterpriseList",
    name: "enterpriseList",
    meta: {
      belong: ["tax"],
      text: "企业列表",
    },
    component: enterpriseList,
  }
  // {
  //   name: 'outConfirm',
  //   meta: {
  //     belong: ['tax'],
  //     text: '账套迁移',
  //   },
  //   path: "/outConfirm",
  //   //迁移任务明细
  //   component: outConfirm,
  // },
];
